<template>
    <div id="app">
        <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav> -->
        <!-- <dv-full-screen-container ref="controll">
      
    </dv-full-screen-container> -->
        <topNav />
        <sideBar />
        <div class="routerBox">
            <router-view />
        </div>
        <pcFooter />
    </div>
</template>

<script>
import topNav from '@/components/topNav/topNav.vue';
import pcFooter from '@/components/footer/pcFooter.vue';
import sideBar from '@/components/sideBar/sideBar.vue';
export default {
    components: {
        topNav,
        pcFooter,
        sideBar,
    },
    mounted() {
        this.getHeight();
    },
    methods: {
        getHeight() {
            let height = window.innerHeight;
            console.log(height);
        },
    },
};
</script>

<style lang="scss">
@font-face {
    font-family: 'PF';
    src: url('./assets/pf.ttf');
    /* 修改为你的字体文件名 */
}

* {
    padding: 0;
    margin: 0;
    transition: all 0.1s;
    // font-size: 16px;
    font-family: 'PF';
    user-select: auto;
}

img,
image {
    vertical-align: top;
}

.act {
    color: #1472ff !important;
}

.colorFFF {
    color: #fff !important;
}

.routerBox {
    min-height: 800px;
}

/* 滚动条整体样式 */
::-webkit-scrollbar {
    width: 8px; /* 滚动条宽度 */
    height: 8px; /* 对于垂直滚动条，这是高度 */
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
    background-color: #8cb4f3; /* 滑块颜色 */
    // border-radius: 10px; /* 圆角 */
}

/* 滚动条轨道 */
::-webkit-scrollbar-track {
    background-color: #fff; /* 轨道颜色 */
}

/* 滚动条滑块在hover时的样式 */
::-webkit-scrollbar-thumb:hover {
    background-color: #8cb4f3;
}
</style>
